import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import {
  BasicNodeLayout,
  DocumentSchemaSource,
  IoType,
  NodeSize,
  NodeType,
  NodeTypeCategory,
  NodeOperationIcon
} from "../Base";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";
import { DataType } from "../../NodeTypes/TypeDefinitions";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.callCustomFieldsSearch,
  label: "Search Custom Fields",
  operationIcon: NodeOperationIcon.search,
  category: NodeTypeCategory.services,
  size: NodeSize.Small,
  controlInputs: [{ name: "call" }],
  controlOutputs: [{ name: "completed", label: "" }],
  dataInputs: [],
  documentDataInputListName: "filters",
  dataOutputs: [{ name: "results", type: DataType.OBJECTLIST }],
  nodeConfigProperties: [
    {
      name: "standardObjectId",
      label: "Standard Object",
      propertyType: NodeConfigPropertyType.StandardObject,
      schemaSourceSystemType: DocumentSchemaSource.customFieldsV1,
      schemaSystem: { createIo: true, ioType: IoType.search },
      options: { customFieldsOnly: true }
    },
    {
      name: "standardObjectName",
      label: "Standard Object Name",
      propertyType: NodeConfigPropertyType.NoInput,
      schemaSourceSystemType: DocumentSchemaSource.customFieldsV1
    },
    {
      name: "customFieldsFilters",
      sectionName: "Custom Fields Filters",
      propertyType: NodeConfigPropertyType.EnabledInputs
    }
  ],
  skipEvaluate: true,
  evaluate: () => {
    return { output: {}, activeControlHandleIds: [] };
  }
});

export const CallCustomFieldsSearchNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  let label = "Search Custom Fields";
  if (data.nodeProperties.standardObjectName) {
    label = `Search ${data.nodeProperties.standardObjectName} Custom Fields`;
    data.nodeProperties.label = label;
  }
  return <BasicNodeLayout id={id} data={data} label={label} />;
};
